import alertOctagon from '@gleam/ui/icons/core/alert-octagon.svg?inline'
import burguer from '@gleam/ui/icons/core/burguer.svg?inline' // <i class="fa-kit fa-burguer"></i>
import chevronDown from '@gleam/ui/icons/core/chevron-down.svg?inline' // <i class="fa-kit fa-chevron-down"></i>
import chevronRight from '@gleam/ui/icons/core/chevron-right.svg?inline' // <i class="fa-kit fa-chevron-right"></i>
import chevronUp from '@gleam/ui/icons/core/chevron-up.svg?inline' // <i class="fa-kit fa-chevron-up"></i>
import close from '@gleam/ui/icons/core/close.svg?inline' // <i class="fa-kit fa-close"></i>
import closeCircle from '@gleam/ui/icons/core/close-circle.svg?inline'
import externalLink from '@gleam/ui/icons/core/external-link.svg?inline'
import gleamColored from '@gleam/ui/icons/core/gleam--colored.svg?inline'
import loader from '@gleam/ui/icons/core/loader.svg?inline'
import search from '@gleam/ui/icons/core/search.svg?inline'
import statusFailed from '@gleam/ui/icons/core/status-failed.svg?inline' // <i class="fa-kit fa-failed-status"></i>

export default {
  alertOctagon,
  burguer,
  chevronDown,
  chevronRight,
  chevronUp,
  close,
  closeCircle,
  externalLink,
  gleamColored,
  loader,
  search,
  statusFailed
}
